import { render } from "./JobEditor.vue?vue&type=template&id=3a2b2f50&scoped=true"
import script from "./JobEditor.vue?vue&type=script&lang=js"
export * from "./JobEditor.vue?vue&type=script&lang=js"

import "./JobEditor.vue?vue&type=style&index=0&id=3a2b2f50&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a2b2f50"]])

export default __exports__